import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, FileTextIcon, LayersIcon, GraduationCapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { MOCKUP_IMAGE, CHECKOUT_MEGAPACK } from '../data/content';
const badges: {
  icon: React.ReactNode;
  label: string;
}[] = [{
  icon: <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-118" data-mp="4njqyesgw3d3" />,
  label: '100% PDF'
}, {
  icon: <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="1285wpmvfbqls" />,
  label: 'Acceso en 5 min'
}, {
  icon: <LayersIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="xbfht2vcv11y" />,
  label: 'Tomo 1 → Tomo 6'
}, {
  icon: <GraduationCapIcon className="h-4 w-4" aria-hidden="true" data-id="element-121" data-mp="sa9q98dflju0" />,
  label: 'Todos los niveles'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-deep text-white" data-id="element-122" data-mp="nbyj55eitnfh">
      <div className="pointer-events-none absolute inset-0 opacity-[0.12]" aria-hidden="true" style={{
      backgroundImage: 'radial-gradient(circle at 20% 20%, #5FB0E5 0, transparent 45%), radial-gradient(circle at 85% 15%, #F5B301 0, transparent 40%)'
    }} data-id="element-123" data-mp="3d2bn1yjw7fzr" />
      <div className="relative mx-auto grid max-w-6xl gap-10 px-5 py-12 sm:py-16 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-8 lg:py-20" data-id="element-124" data-mp="3o6u71a6kmrcx">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-125" data-mp="3e8wjyq0g70lw">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-celeste-light ring-1 ring-white/20" data-id="element-126" data-mp="30g6l3kztm17d">
            🇦🇷 MegaPack™
          </span>

          <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.05] text-balance sm:text-5xl lg:text-6xl" data-id="element-127" data-mp="2vietyt702j48">
            Todo tu año de{' '}
            <span className="text-gold" data-id="element-128" data-mp="2hjymh01bcol1">Caligrafía y Lectoescritura</span>.
            <br data-id="element-129" data-mp="2ljgz78izdtcs" />
            Listo. Desde hoy.
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-celeste-light sm:text-lg" data-id="element-130" data-mp="s1rt2qgj2avc">
            El sistema N°1 para padres y docentes en Argentina — Tomo 1 → Tomo 6 —
            Todos los niveles.
          </p>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-white/80" data-id="element-131" data-mp="id9v0gzmuhve">
            Actividades + diplomas + guías listas para usar.{' '}
            <strong className="font-bold text-white" data-id="element-132" data-mp="dbapb0gf78va">
              Sin buscar. Sin armar. Sin perder domingos.
            </strong>
          </p>

          <ul className="mt-7 flex flex-wrap gap-2" data-id="element-133" data-mp="161j7utevbvae">
            {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white ring-1 ring-white/15 sm:text-sm" data-id="element-134" data-mp="111yd6v6qe93h">
                <span className="text-gold" data-id="element-135" data-mp="3lui9cqv5izld">{badge.icon}</span>
                {badge.label}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-136" data-mp="1x9b6f48dr7e5">
            <CtaButton href={CHECKOUT_MEGAPACK} className="w-full sm:w-auto" data-id="element-137" data-mp="1xacgb5dntnua">
              🇦🇷 → Quiero mi MegaPack ahora
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-semibold text-white/70 sm:text-sm" data-id="element-138" data-mp="269zjnwpy93pz">
            <li className="inline-flex items-center gap-1.5" data-id="element-139" data-mp="2b0zduu7op7os">
              <ShieldCheckIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-140" data-mp="2b2kbwtt7j8re" />
              Garantía 7 días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="2kydryn64xkdx">
              <LockIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-142" data-mp="2l0q9iz7zdsqg" />
              Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="2tzbq4otw6xol">
              <CreditCardIcon className="h-4 w-4 text-celeste" aria-hidden="true" data-id="element-144" data-mp="2tysgdveebfln" />
              Mercado Pago
            </li>
          </ul>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} data-id="element-145" data-mp="zmluo2nvlgf3">
          <div className="absolute inset-6 rounded-[40px] bg-celeste/25 blur-3xl" aria-hidden="true" data-id="element-146" data-mp="3vh5ju6cof677" />
          <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-[32px] ring-1 ring-white/15 lg:max-w-none" data-id="element-147" data-mp="9ah3f4ptqnyp">
            <img src={MOCKUP_IMAGE} alt="MegaPack Caligrafía y Lectoescritura: libro principal con fichas de vocales, consonantes, sílabas, cursiva, lectura y diplomas imprimibles" className="block w-full" width={1024} height={1024} data-id="element-148" data-mp="3hphcegddh5wk" />
          </div>
        </motion.div>
      </div>
    </header>;
}